import { useTranslation } from "react-i18next";
import type { CampaignStatusName } from "@multi-chat/shared";
import { cn } from "../../lib/utils.js";
import { campaignStatusChipClass, campaignStatusIcon } from "./campaigns-presentation.js";
import { CampaignProcessingIcon } from "./CampaignProcessingIcon.js";

export function CampaignStatusBadge({
  status,
}: {
  status: CampaignStatusName;
}): React.JSX.Element {
  const { t } = useTranslation();
  const Icon = campaignStatusIcon(status);

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[0.6875rem] font-medium",
        campaignStatusChipClass(status),
      )}
      data-testid="campaign-status"
    >
      {status === "RUNNING" ? <CampaignProcessingIcon /> : <Icon size={12} aria-hidden="true" />}
      {t(`campaigns.status.${status}`)}
    </span>
  );
}
